#import "../fragments/sms-broadcast-light-fragment.graphql"

query GetSmsBroadcasts(
    $archived: Boolean
    $statuses: [EditionStatus!]!
    $assigneeIds: [ID!]
    $lastUpdatedTime: String
    $creatorUserId: String
    $search: String
) {
    smsBroadcasts(
        archived: $archived
        statuses: $statuses
        assigneeIds: $assigneeIds
        modifiedSinceTime: $lastUpdatedTime
        creatorUserId: $creatorUserId
        search: $search
    ) {
        ...SmsBroadcastLightFragment
    }
}
